import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

export const defaultWarning = {
  isWarningShown: false,
};

export const warningAtom = atom({ key: 'warningAtom', default: { ...defaultWarning }, effects_UNSTABLE: [persistAtom] });
